define('modules/form_editor/views/editor_custom_privacy',['require','exports','module','base/collectionview','lib/util','../behaviours/has_uploader','ldsh!../templates/editor_custom_privacy','./editor_checkradio_item'],function(require,exports,module) {
  "use strict";

  var CollectionView = require("base/collectionview"),
      util = require("lib/util"),
      uploaderBehaviour = require("../behaviours/has_uploader");

  var CustomPrivacyEditorView = CollectionView.extend({
    template: require("ldsh!../templates/editor_custom_privacy"),
    itemContainer: ".js-items",
    itemView: require("./editor_checkradio_item"),

    events: {
      "change textarea": "updateModel",
      "click .js-help": "triggerTooltip"
    },

    initialize: function(options) {
      this.collection = this.model.items;
      this.listenTo(this.childVent, "item:add", this.addNewItem);
      this.listenTo(this.childVent, "item:remove", this.removeItem);

      this.options = options.options;
      if(!this.options.pages_id) {
        throw new Error("Need pageId to upload terms");
      }
      if(!this.options.variants_id) {
        this.options.variants_id = "main";
      }
    },

    triggerTooltip: function(e) {
      this.$(".js-tooltip").toggleClass("in");
    },

    updateModel: function(e) {
      e.preventDefault();
      this.stopListening(this.model);
      this.model.set("informationText", this.$(".js-informationText").val().trim());
      this.listenTo(this.model, "change", this.render);
      this.trigger("item:change", this.model);
    },

    addNewItem: function(view) {
      this.model.addItemAfter(view.model);
    },

    removeItem: function(view) {
      this.model.removeItem(view.model);
    },

    onRender: function() {
      this.$el.i18n();
      this._setupUploader();
    }
  });

  module.exports = CustomPrivacyEditorView;

  util.mixin(module.exports, uploaderBehaviour);

});

